/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import Box from "@mui/material/Box";
import { TextField } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { CacheContext } from "../../Context/cacheContext";
import moment from "moment";
import GenericAutocompleteModal from "../../Modal/GenericAutocompleteModal";
import User from "../Users/User";
import { Vocabulary } from "../../Utils/Vocabulary";
import { vehicleModel } from "../../Models/vehicleDetails";
import CompanyModal from "../../Components/Settings/CompanyModal";
import { schema } from "../../Validators/vehicleValidators";

import { AUTODELRULATE_AD_LINK } from "../../Utils/Constants";
import {
  NUMBER_OF_DECIMALS,
  getBnrEuroRate,
  isMobile,
  sanitizeForAutocomplete,
} from "../../Utils/utils";
import { VehicleContext } from "../../Context/vehicleContext";
import {
  AutocompleteModel,
  AutocompleteModelForVehicleModels,
} from "../../Models/Models";
import { PurchaseTypes, VehiclesStatus } from "../../Utils/autocompleteEnum";
import PostAdsIntegrationModal from "../VehicleDasboard/PostAdsIntegrationModal";
import DocumentsModal from "../DocumentsModal";
import { useNavigate } from "react-router-dom";
import { useAutocompleteModal } from "./useAutocompleteModal";
import { useDescriptionTemplates } from "./useDescriptionTemplates";
import { useAdGeneration } from "./useAdGeneration";
import { useVehicleRefresh } from "./useVehicleRefresh";
import { VehicleEquipmentSection } from "./VehicleEquipmentSection";
import { VehicleDescriptionSection } from "./VehicleDescriptionSection";
import { VehicleInformationSection } from "./VehicleInformationSection";
import { VehicleAdministrativeSection } from "./VehicleAdministrativeSection";

export default function VehicleMainInfo(props) {
  const cacheContext = useContext(CacheContext);
  const vehicleContext = useContext(VehicleContext);
  const [sortedModels, setSortedModels] = useState([]);
  const [dotari, setDotari] = useState();

  const [brandId, setBrandId] = useState(
    new AutocompleteModelForVehicleModels(),
  );
  const autocompleteModal = useAutocompleteModal({ brandId });
  const {
    genericAutocompleteModel,
    setGenericAutocompleteModel,
    DropDownButton,
    EditButton,
    EditButtonCompany,
    openModalUser,
    setOpenModalUser,
    openModalCompany,
    setOpenModalCompany,
  } = autocompleteModal;

  const [TVADeductibil, setTVADeductibil] = useState(0);
  const [TVARecovered, setTVARecovered] = useState(0);
  const [date, setDate] = useState({
    data_achizitie: null,
    data_receptie: null,
    data_vanzare: null,
  });

  const [modelCar, setModelCar] = useState(vehicleModel);
  const [siteLink, setSiteLink] = useState(null);
  // const navigate = useNavigate();
  const [bnrEuroExchangeRate, setBnrEuroExchangeRate] = useState(1);
  const {
    handleSubmit,
    control,
    setValue,
    formState,
    getValues,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...sanitizeForAutocomplete(vehicleContext.state.vehicle),
      user_achizitie_id:
        vehicleContext?.state?.vehicle?.id === 0
          ? parseInt(localStorage.getItem("useId"))
          : vehicleContext?.state?.vehicle?.user_achizitie_id,
      user_achizitie_r:
        vehicleContext?.state?.vehicle?.id === 0
          ? cacheContext.cache.users.find(
              (user) => user?.id === parseInt(localStorage.getItem("useId")),
            )
          : cacheContext.cache.users.find(
              (user) =>
                user.id === vehicleContext?.state?.vehicle?.user_achizitie_id,
            ),
    },
  });
  const formRef = useRef();
  const tip_achizitie = watch("tip_achizitie_r");
  const statusId = watch("status_id");
  const soldStatusID = useMemo(() => {
    const sold = cacheContext.cache.vehicleStatus?.find(
      (item) => item.nume === VehiclesStatus.sold,
    );
    return sold?.id ? sold?.id : 0;
  }, [cacheContext.cache.vehicleStatus]);
  const isSold = statusId === soldStatusID;
  const [openIntegrationModal, setOpenIntegrationModal] = useState(false);
  const promotedAt = watch("promoted_at");
  const [openReceiveModal, setOpenReceiveModal] = useState(false);
  const document = vehicleContext?.state?.documents?.length
    ? vehicleContext?.state?.documents?.find((document) =>
        document?.descriere_financiar?.toLowerCase().includes("cmr"),
      )
    : null;
  const [cmr, setCmrDocument] = useState(document);
  const navigate = useNavigate();
  const { descriptionTemplates, selectedTemplate, setSelectedTemplate, getDescriptionTemplates } =
    useDescriptionTemplates({ cacheContext, vehicleContext, setValue, getValues });
  const { generateAd, handlePromotingAd } = useAdGeneration({
    formState,
    vehicleContext,
    siteLink,
    setValue,
  });
  const { getNewData } = useVehicleRefresh({ vehicleContext });

  /**
   *
   */
  useEffect(() => {
    reset(vehicleContext.state.vehicle);
    if (vehicleContext?.state?.documents?.length) {
      const document = vehicleContext?.state?.documents?.find((document) =>
        document.descriere_financiar?.toLowerCase().includes("cmr"),
      );
      setCmrDocument(document);
    }
  }, [vehicleContext.state.vehicle]);

  /**
   *
   */
  useEffect(() => {
    setModels(formState.defaultValues?.brand_id, cacheContext.cache?.models);
    if (!vehicleContext?.state?.vehicle?.id) {
      getBnrEuroRate().then((exchangeRate) => {
        setBnrEuroExchangeRate(
          parseFloat(
            parseFloat(exchangeRate.toString()).toFixed(NUMBER_OF_DECIMALS),
          ),
        );
      });
    }
    //aduce toate sabloanele pentru descriere
    getDescriptionTemplates();
  }, []);

  /**
   *
   */
  useEffect(() => {
    if (genericAutocompleteModel.id === "model_r")
      setModels(brandId.brand_id, cacheContext.cache?.models);
  }, [genericAutocompleteModel.open]);

  /**
   *
   */
  useEffect(() => {
    const localModel = Object.assign({}, modelCar);
    if (formState.defaultValues) {
      localModel.vin = formState.defaultValues?.vin;
      setDate({
        data_achizitie: formState.defaultValues?.data_achizitie,
        data_receptie: formState.defaultValues?.data_receptie,
      });
      setTVADeductibil(formState.defaultValues?.tva_id);
      setTVARecovered(formState.defaultValues?.TvaRecovered);
      const allData = [];
      formState.defaultValues &&
        formState.defaultValues?.dotari?.forEach((element) => {
          allData.push(element.id);
        });
      setDotari(formState.defaultValues?.dotari);

      // Vizible on Site
      if (!siteLink && formState.defaultValues?.slug) {
        setSiteLink(AUTODELRULATE_AD_LINK + formState.defaultValues?.slug);
      }
    }

    setModelCar(localModel);
    setBrandId({
      ...brandId,
      brand_id: formState.defaultValues
        ? formState.defaultValues?.brand_r?.id
        : 1,
    });
  }, [formState.defaultValues]);

  /**
   *
   * @param {*} data
   */
  const onSubmit = (
    data,
    disableTostify = false,
    showIntegrationModal = true,
  ) => {
    if (typeof disableTostify != "boolean") disableTostify = false;
    const newData = Object.assign({}, data);

    //VALIDATION TO NOT SEND EMPTY STRING TO BACKEND
    newData.pret_minim_vanzare =
      data.pret_minim_vanzare === "" ? 0 : data.pret_minim_vanzare;
    newData.numar_portiere =
      data.numar_portiere === "" ? 5 : data.numar_portiere;
    newData.nr_locuri = data.nr_locuri === "" ? 5 : data.nr_locuri;
    newData.kilometri = data.kilometri === "" ? 0 : data.kilometri;
    newData.an_fabricatie = data.an_fabricatie === "" ? 0 : data.an_fabricatie;

    // Handle physical_location - extract string from object if needed
    if (newData.physical_location) {
      if (
        typeof newData.physical_location === "object" &&
        newData.physical_location.nume
      ) {
        newData.physical_location = newData.physical_location.nume;
      }
      // If it's already a string, keep it as is
    }

    //DATE
    newData.data_achizitie = data.data_achizitie
      ? moment(data.data_achizitie).format("YYYY-MM-DD HH:mm:ss")
      : null;
    newData.data_receptie = data.data_receptie
      ? moment(data.data_receptie).format("YYYY-MM-DD HH:mm:ss")
      : null;
    newData.data_vanzare = data.data_vanzare
      ? moment(data.data_vanzare).format("YYYY-MM-DD HH:mm:ss")
      : null;
    newData.data_inmatriculare = newData.data_inmatriculare
      ? moment(newData.data_inmatriculare).format("YYYY-MM-DD HH:mm:ss")
      : null;
    newData.rar_scheduled_date = data.rar_scheduled_date
      ? moment(data.rar_scheduled_date).format("YYYY-MM-DD")
      : null;
    newData.itp_valid_until = data.itp_valid_until
      ? moment(data.itp_valid_until).format("YYYY-MM-DD")
      : null;
    newData.rca_valid_until = data.rca_valid_until
      ? moment(data.rca_valid_until).format("YYYY-MM-DD")
      : null;
    if (newData.obsTVA) {
      newData.obsTVA = data.obsTVA;
    } else {
      newData.obsTVA = null;
    }

    ///DOTARI

    newData.dotari = dotari;

    //STATUS
    if (!newData.status_id) {
      const inTransitStatus = cacheContext.cache?.vehicleStatus?.find(
        (status) => status.nume === VehiclesStatus.inTransitStatus,
      );

      if (newData.tip_achizitie_id) {
        const tipAchizitie = cacheContext.cache?.purchaseType?.find((item) => {
          if (newData.tip_achizitie_id && newData.tip_achizitie_id[0]?.id)
            return item.id === newData.tip_achizitie_id[0]?.id;
          if (newData.tip_achizitie_id && !newData.tip_achizitie_id[0]?.id)
            return item.id === newData.tip_achizitie_id;
          return null;
        });
        if (
          tipAchizitie?.nume === PurchaseTypes.buyBack ||
          tipAchizitie?.nume === PurchaseTypes.national
        ) {
          newData.status_id = cacheContext.cache?.vehicleStatus?.find(
            (status) => status.nume === VehiclesStatus.received,
          ).id;
          newData.physical_status_id = newData?.status_id;
          newData.main_status_id = newData?.status_id;
        } else {
          newData.status_id = cacheContext.cache?.vehicleStatus?.find(
            (status) => status.nume === VehiclesStatus.unpaid,
          ).id;
          newData.physical_status_id = inTransitStatus?.id;
          newData.main_status_id = inTransitStatus?.id;
        }
      } else {
        newData.status_id = cacheContext.cache?.vehicleStatus?.find(
          (status) => status.nume === VehiclesStatus.unpaid,
        ).id;
        newData.physical_status_id = inTransitStatus?.id;
        newData.main_status_id = inTransitStatus?.id;
      }
    }
    // CURS BNR
    if (!vehicleContext?.state?.vehicle?.id) {
      newData.cursEuro = bnrEuroExchangeRate;
    }

    if (showIntegrationModal) setOpenIntegrationModal(true);
    // VISIBIL PE SITE
    return updateVehicle(newData, disableTostify);
  };

  const onError = (data) => {
    // eslint-disable-next-line no-console
    console.log(data); //E lasat aici pentru a vedeam campurile care nu sunt completate
  };

  /**
   *
   * @param {*} data
   */
  async function updateVehicle(data, disableTostify = false) {
    const vehicle = await vehicleContext.saveWithoutFile(
      () => true,
      null,
      null,
      data,
      disableTostify,
    );

    if (vehicle?.id) {
      navigate(`/vehiclesDashboard/vehicleDetails/${vehicle.id}`);
    }
  }

  /**
   *
   * @param {*} data
   */
  const handleDotari = (data) => {
    setDotari(data);
  };

  /**
   *
   * @param {*} data
   * @param {*} cache
   * @returns
   */
  const setModels = (data, cache) => {
    const filteredModels = [];
    cache.forEach((value) => {
      if (value.brand_id === data) {
        filteredModels.push(value);
      }
    });
    setSortedModels(filteredModels);
    return filteredModels;
  };

  /**
   *
   * @param {*} data
   */
  const setBrand = (data) => {
    setBrandId({ ...brandId, brand_id: data.id });
    setSortedModels(setModels(data.id, cacheContext.cache?.models));
  };

  /**
   *
   * @param {*} data
   */
  const setTvaDeductibil = (data) => {
    setTVARecovered("0");
    setTVADeductibil(data.id);
  };

  /**
   * Determines if the selling data can be changed based on the state
   * of the edit button and vehicle information.
   *
   * @returns {boolean} True if the selling data can be changed, false otherwise.
   */

  const permissionToChangeSellingData = () => {
    const isDisabled = props.editButton;
    if (isDisabled) {
      return true;
    }
    if (props?.info?.editSoldVehicle) {
      return false;
    }
    return true;
  };
  /**
   * Save the receive date
   * @param {Date} date the new date
   */
  const handleSaveReceiveDate = (date) => {
    const data = getValues();
    data.data_receptie = date;

    const statusReceived = cacheContext.cache?.vehicleStatus?.find(
      (status) => status.nume === VehiclesStatus.received,
    );
    data.physical_status_id = statusReceived?.id;
    data.main_status_id = statusReceived?.id;

    if (!data?.clientId) {
      data.main_status_id = statusReceived?.id;
    } else {
      const statusReserved = cacheContext.cache?.vehicleStatus?.find(
        (status) => status.nume === VehiclesStatus.reserved,
      );
      if (statusReserved) data.status_id = statusReserved?.id;
    }

    // call the onSubmit function with the new data
    onSubmit(data, true, false);
  };


  return (
    <Box style={{ paddingBottom: "10rem" }}>
      <form
        method="get"
        id="formVehicleDetails"
        onSubmit={handleSubmit(onSubmit, onError)}
        noValidate
        ref={formRef}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            flexDirection: isMobile() ? "column" : "row",
          }}
        >
          <VehicleInformationSection
            control={control}
            formState={formState}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
            editButton={props.editButton}
            info={props.info}
            cache={cacheContext.cache}
            sortedModels={sortedModels}
            setBrand={setBrand}
            DropDownButton={DropDownButton}
          />
          <VehicleAdministrativeSection
            formApi={{ control, formState, getValues, setValue }}
            permissions={{ editButton: props.editButton, info: props.info, sellBonus: props.sellBonus }}
            cache={cacheContext.cache}
            autocompleteControls={{ EditButton, EditButtonCompany, DropDownButton }}
            tip_achizitie={tip_achizitie}
            isSold={isSold}
            permissionToChangeSellingData={permissionToChangeSellingData}
            tvaState={{ TVADeductibil, setTvaDeductibil, TVARecovered, setTVARecovered }}
            bnrEuroExchangeRate={bnrEuroExchangeRate}
            dateState={{ date, setDate }}
            cmr={cmr}
            setOpenReceiveModal={setOpenReceiveModal}
            dotari={dotari}
            adState={{ siteLink, promotedAt }}
            actions={{ handlePromotingAd, generateAd, onSubmit, setOpenIntegrationModal }}
          />
        </div>

        <VehicleEquipmentSection
          control={control}
          formState={formState}
          editButton={props.editButton}
          facilities={cacheContext.cache?.facilities}
          onDotariChange={handleDotari}
        />
        <VehicleDescriptionSection
          control={control}
          formState={formState}
          editButton={props.editButton}
          descriptionTemplates={descriptionTemplates}
          selectedTemplate={selectedTemplate}
          setSelectedTemplate={setSelectedTemplate}
          setValue={setValue}
          vehicle={vehicleContext.state.vehicle}
          cache={cacheContext.cache}
        />

        {/** NOTES */}
        <fieldset
          style={{
            marginTop: 50,
            borderRadius: 10,
            margin: 10,
            borderColor: "#d6d6d6",
            borderStyle: "solid",
            color: "#444",
          }}
        >
          <legend>{Vocabulary.notes}</legend>
          <Controller
            defaultValue={formState.defaultValues?.notite}
            name="notite"
            control={control}
            render={({ field: { value, onChange } }) => (
              <TextField
                style={{ width: "100%" }}
                onChange={onChange}
                value={value}
                disabled={props.editButton}
                id="notite"
                label={Vocabulary.notes}
                size="small"
                variant="standard"
                multiline
                rows={3}
              />
            )}
          />
        </fieldset>
      </form>

      {genericAutocompleteModel.open && (
        <GenericAutocompleteModal
          open={genericAutocompleteModel.open}
          onClose={() =>
            setGenericAutocompleteModel({
              ...genericAutocompleteModel,
              open: false,
              modelForFields: new AutocompleteModel(),
            })
          }
          title={genericAutocompleteModel.title}
          data={genericAutocompleteModel.data}
          id={genericAutocompleteModel.id}
          columns={genericAutocompleteModel.columns}
          validationSchema={genericAutocompleteModel.validationSchema}
          hiddenFieldsArray={genericAutocompleteModel.hiddenFieldsArray}
          modelForFields={genericAutocompleteModel.modelForFields}
          width={1000}
          onEdit={(_, tableMeta) => {
            // Get the original data object which contains all fields (including brand_id for models)
            const originalData = genericAutocompleteModel.data[tableMeta.rowIndex];

            setGenericAutocompleteModel({
              ...genericAutocompleteModel,
              modelForFields: { ...originalData },
            });
          }}
          onSucces={() => {
            setModels(brandId.brand_id, cacheContext.cache?.models);
            setValue(genericAutocompleteModel.id, null);
          }}
        ></GenericAutocompleteModal>
      )}
      <User
        open={openModalUser}
        onClose={() => setOpenModalUser(false)}
        title={Vocabulary.addNewUser}
      />
      <CompanyModal
        open={openModalCompany}
        title={Vocabulary.addNewCompany}
        onClose={() => setOpenModalCompany(false)}
      ></CompanyModal>
      <PostAdsIntegrationModal
        open={openIntegrationModal}
        setOpen={setOpenIntegrationModal}
        vehicle={
          vehicleContext.state.vehicle
            ? Object.assign({}, vehicleContext.state.vehicle)
            : {}
        }
        setVehicle={vehicleContext.updateVehicle}
        getDataRefresh={() =>
          setSiteLink(
            AUTODELRULATE_AD_LINK + vehicleContext.state.vehicle?.slug,
          )
        }
      />
      <DocumentsModal
        templateData={{
          id: "test",
          tip_fisier: "Acte",
          descriere_financiar: "Cmr",
          suma_financiar: 0,
        }}
        open={openReceiveModal}
        onClose={() => setOpenReceiveModal(false)}
        title={Vocabulary.addCMRDocument}
        afterSave={(date) => handleSaveReceiveDate(date)}
        getNewData={getNewData}
      />
    </Box>
  );
}
